// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3Y3nq","label":"Labeled_label__Lccc_","divider":"Labeled_divider__3uBds"};